<template>
    <div class="vue-need-bootstrap h100">
        <div class="auth-background">
            <div class="auth-content" :class="{ 'with-pitch': !!slot.pitch }">
                <div v-if="slot.pitch" class="auth-pitch">
                    <slot name="pitch" />
                </div>
                <div class="auth-card">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useSlots } from 'vue';

const slot = useSlots();
</script>

<style scoped lang="scss">
@import 'styles/utilities/functions';

.auth-background {
    height: 100%;
    display: flex;
    padding: 40px 15px;
    background: linear-gradient(90deg, get-color('purple') 0%, #7bd5dc 100%);
    .auth-content {
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 815px;
        &.with-pitch {
            max-width: 1500px;
            gap: 64px;
            .auth-card {
                flex: 0 0 600px;
                max-width: 600px;
            }
        }
        .auth-card {
            background: get-color('white');
            border-radius: 1rem;
            box-shadow: 0 1px 8px rgba(0, 0, 0, 0.14);
            padding: 24px;
            width: 100%;
            max-width: 600px;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
        }

        .auth-pitch {
            flex: 1 1 0;
            min-width: 0;
        }
    }
}

@media (max-width: 991px) {
    .auth-content.with-pitch {
        flex-direction: column;
        gap: 32px;
    }

    .auth-content.with-pitch .auth-card {
        flex: 1 1 auto;
        max-width: 600px;
    }
}
</style>
